export default {
  // temporarily suppressing login link during checkout
  // due to a session handoff bug. (see WBRT-2148)
  loginStatus: { component: () => null },
};
